export default class myClass{
	constructor($scope){
		$scope.nombre = 'indicadores';
	}
}



// WEBPACK FOOTER //
// ./app/js/controllers/indicadores/indicadores.js